// Horizontal bands jump sideways
vec3 effect(vec2 uv)
{
    float band = floor(uv.y * 30.0);
    float tick = floor(uTime * 8.0);
    float shift = step(1.0 - uAmount * 0.5, random(vec2(band, tick))) * (random(vec2(tick, band)) - 0.5) * 0.2;
    vec2 guv = vec2(uv.x + shift, uv.y);
    vec3 color = vec3(sampleCam(guv + vec2(0.01, 0.0)).r, sampleCam(guv).g, sampleCam(guv - vec2(0.01, 0.0)).b);
    return color + (random(uv * uTime) - 0.5) * 0.15;
}
